module.exports = __webpack_public_path__ + "img/star-checkmark.07ea83d9.svg";